import { IonApp, IonContent, IonPage } from "@ionic/react";
import BackButtonTitle from "components/mobile-components/Common/BackButtonTitle";
import ChangeLanguage from "components/mobile-components/Profile/ChangeLanguage";
import React from "react";
import { useSelector } from "react-redux";

export default function ChangeLanguagePage() {
	const ekkLanguage = useSelector((state) => state.lan.lan);

	return (
		<IonApp>
			<IonPage className='business-name'>
				<IonContent>
					<BackButtonTitle title={ekkLanguage.changeLanguages.pageTitle} />
					<ChangeLanguage />
				</IonContent>
			</IonPage>
		</IonApp>
	);
}
